export const aboutData = {
    title: "Who I am",
    description1: "Hi, I am Tarek! I am an experienced WordPress designer and a full-stack software developer. After two years of designing and developing responsive websites using WordPress (for e-commerce stores and learning management systems), I decided to join Microverse, which teaches software development through remote pair programming.",
    description2: "",
    image: 1
}
